import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { ProductOld } from 'src/admin-entity/interface/product/product-old.interface';

export interface ProductFundingInitType {
    page: number;
    take: number;
    productName: string;
    productOptionName: string;
    distributorName: string;
    productStatus: string;
    saleType: string;
    searchResult: {
        products: ProductOld[];
        page: {
            count: number;
        };
    };
}

export const productFundingInitState: ProductFundingInitType = {
    page: 0,
    take: 10,
    productName: '',
    productOptionName: '',
    distributorName: '',
    productStatus: '',
    saleType: '',
    searchResult: {
        products: [],
        page: {
            count: 0,
        },
    },
};
